import { EstadoModel } from "./EstadoModel";
import CidadeModel from '../cadastros/saude/CidadeModel';

export interface EnderecoModel {
  id?: number;
  cep?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  estado?: EstadoModel;
  tipo?: TipoEnderecoModel;
  cidadeModel?: CidadeModel;
}

export const tiposEnderecoList: TipoEnderecoModel[] = [
  { nome: "RESIDENCIAL", descricao: "Residencial" },
  { nome: "COMERCIAL", descricao: "Comercial" },
  { nome: "OUTRO", descricao: "Outro" },
];


export interface TipoEnderecoModel {
  nome: string;
  descricao: string;
}

export const COMERCIAL: TipoEnderecoModel = { nome: "COMERCIAL", descricao: "Comercial" };